(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["xustom-top-bar"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('DOMContentLoaded', function() {
  // Slider functionality
  const slider = document.querySelector('.custom-top-bar__announcement-slider');
  const slides = document.querySelectorAll('.custom-top-bar__announcement-slide');
  const prevBtn = document.querySelector('.custom-top-bar__announcement-arrow--prev');
  const nextBtn = document.querySelector('.custom-top-bar__announcement-arrow--next');
  let currentSlide = 0;

  function updateSlider() {
    slider.style.transform = `translateX(-${currentSlide * 100}%)`;
  }

  function nextSlide() {
    currentSlide = (currentSlide + 1) % slides.length;
    updateSlider();
  }

  function prevSlide() {
    currentSlide = (currentSlide - 1 + slides.length) % slides.length;
    updateSlider();
  }

  setInterval(nextSlide, 5000);

  nextBtn.addEventListener('click', nextSlide);
  prevBtn.addEventListener('click', prevSlide);
});

  } catch(e) { console.error(e); }
})();
})();
